import * as React from 'react';
import DynamicIcon from './dynamicicon';
import JisButton from './controls/jisButton';

export default function JisAlert({title="", subtitle="", actiontext="Ok",icon="done", onOk}) {

  return (
    <div className={ "dialog-box open" }>
                    
                   
                        <div className="wrapper">
                          <div className='circle'>
                             <DynamicIcon iname={icon} size={40} />
                          </div>
                          
                        <h3>{title} </h3>
                        <div className="main">
                          
                            <p style={{marginTop:16, marginBottom:16, textAlign:'center'}}>{subtitle}</p>
                           
                            <div className="btns">
                              
                                <JisButton onClick={onOk}>{actiontext} </JisButton>
                            </div>  
                        </div>
                    </div>
                    
                    
                </div>

  );
}
